import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Link } from '@spotahome/ui-library';

import './TextBlock.scss';

const TextBlock = ({ title, description, cta = null, className = '' }) => {
  return (
    <div className={classNames('tenant-guarantees-help-text-block', className)}>
      <div className="tenant-guarantees-help-text-block__content">
        <div className="tenant-guarantees-help-text-block__title-container">
          <div className="tenant-guarantees-help-text-block__title-label">
            SPOTAHOME BLOG
          </div>
          <h3 className="tenant-guarantees-help-text-block__title">{title}</h3>
        </div>
        <p className="tenant-guarantees-help-text-block__text">{description}</p>
        {cta && (
          <Link
            href={cta.url}
            className="tenant-guarantees-help-text-block__cta"
          >
            {cta.text}
          </Link>
        )}
      </div>
    </div>
  );
};

TextBlock.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cta: PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }),
  className: PropTypes.string
};

export default TextBlock;
